export default __webpack_public_path__ + "31ffae68625a0e17dd55b6f957b0aacc.svg";